import { render, staticRenderFns } from "./dataStatistics.vue?vue&type=template&id=5083f1b6&scoped=true&"
import script from "./dataStatistics.vue?vue&type=script&lang=js&"
export * from "./dataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./dataStatistics.vue?vue&type=style&index=0&id=5083f1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083f1b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5083f1b6')) {
      api.createRecord('5083f1b6', component.options)
    } else {
      api.reload('5083f1b6', component.options)
    }
    module.hot.accept("./dataStatistics.vue?vue&type=template&id=5083f1b6&scoped=true&", function () {
      api.rerender('5083f1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataStatistics/dataStatistics.vue"
export default component.exports